export default __webpack_public_path__ + "static/invictus-d98ae2ff9ae0ba4f2faf72d404a4af8b.png";